export class AwsNativePitrBackupPolicyPlan {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "retentionDays",
            "baseName": "retentionDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "AwsNativePitrBackupResourceType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsNativePitrBackupPolicyPlan.attributeTypeMap;
    }
    constructor() {
    }
}
